"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EntityTypes;
(function (EntityTypes) {
    EntityTypes["SYNONYM"] = "SYNONYM";
    EntityTypes["DATA"] = "DATA";
    EntityTypes["BRANCH"] = "BRANCH";
})(EntityTypes || (EntityTypes = {}));
exports.default = EntityTypes;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRW50aXR5VHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvZXZhbHVhdG9yL0VudGl0eVR5cGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsSUFBSyxXQUlKO0FBSkQsV0FBSyxXQUFXO0lBQ2Qsa0NBQW1CLENBQUE7SUFDbkIsNEJBQWEsQ0FBQTtJQUNiLGdDQUFpQixDQUFBO0FBQ25CLENBQUMsRUFKSSxXQUFXLEtBQVgsV0FBVyxRQUlmO0FBRUQsa0JBQWUsV0FBVyxDQUFDIn0=